import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { ContainerGroupField } from '@/components/common'
import { InputControl } from '@/components/form-controls'
import { ContactEmergencyFormData } from '@/types/forms'

interface NamesEmergencyControlProps {
    control: Control<ContactEmergencyFormData>
}

export const NamesEmergencyControl = ({
    control
}: NamesEmergencyControlProps): JSX.Element => {
    const { t } = useTranslation()

    return (
        <ContainerGroupField tittleGroup={t('forms.groups.namesEmergency')}>
            <InputControl
                name="firstName"
                forceUppercase
                control={control}
                label={t('forms.common.firstName')}
                rules={{
                    required: t('forms.common.required.firstNameRequired')
                }}
            />

            <InputControl
                name="middleName"
                forceUppercase
                control={control}
                label={t('forms.common.middleName')}
            />

            <InputControl
                name="firstLastName"
                forceUppercase
                control={control}
                label={t('forms.common.firstLastName')}
                rules={{
                    required: t('forms.common.required.firstLastNameRequired')
                }}
            />
            <InputControl
                name="secondLastName"
                forceUppercase
                control={control}
                label={t('forms.common.secondLastName')}
            />
        </ContainerGroupField>
    )
}
